import React from "react";
import TeamMemberCard from "../../../../components/teamMemberCard";

const teamMembers = [
  {
    name: "Mrs. Pasima Sule",
    description1: "Founder & CEO, OnTrack Careers",
    description2: "AI Strategy and Product Development ",
    link: "https://www.linkedin.com/in/pasima-sule-215699204/",
    image: "/mentors/1.png",
  },
  {
    name: "Dr. Ife Adebara",
    description1:
      "Research & Teaching Assistant, University of British Columbia",
    description2: "Expert in AI, NLP & Afrocentric AI Tools",
    link: "https://www.linkedin.com/in/ife-adebara-phd-3623a56a/",
    image: "/mentors/3.png",
  },
  {
    name: "Mr. Nene Azu",
    description1: "Senior Lead Product Manager, RBC Borealis AI",
    description2: "AI Product Strategy",
    link: "https://www.linkedin.com/in/neneazu/",
    image: "/mentors/2.png",
  },
  {
    name: "Dr. James Rout",
    description1: "Executive Director, Cognitive Analytics Institute",
    description2: "AI Strategy & Innovation",
    link: "https://www.linkedin.com/in/jamesrout/",
    image: "/mentors/6.png",
  },
  {
    name: "Dr. Debbie Motilewa",
    description1:
      "Senior Product Manager - Knowledge Management & AI, Amazon Pharmacy",
    description2: "AI Powered Systems ",
    link: "https://www.linkedin.com/in/debbiemotilewa/",
    image: "/mentors/Dr Debbie Motilewa.png",
  },
  {
    name: "Mr. Nic Oguname",
    description1: "Enterprise Technology",
    description2: "Manager, Cybersecurity Risk",
    link: "https://www.linkedin.com/in/nicoguname/",
    image: "/mentors/5.png",
  },
  {
    name: "Mais Jemimah Maigari",
    description1: "ATB Financial",
    description2: "AI Automation Analyst ",
    link: "https://www.linkedin.com/in/mais-jemimah-maigari-00084290/",
    image: "/mentors/4.png",
  },
  {
    name: "Jennifer Akporero, SHRM-CP, CPHR",
    description1: "Human Resources Manager",
    description2: "AI Tools for Career Development",
    image: "/mentors/Mrs Jennifer Akporero.png",
    link: "https://www.linkedin.com/in/jennifer-akporero-shrm-cp-cphr-b7901219a/",
  },
  {
    name: "Usman Saif, MSSE",
    description2: "Software & AI Consultant",
    description1: "Senior Software/AI Engineer",
    image: "/mentors/osman.png",
    link: "https://www.linkedin.com/in/usman-saif-a15a17102/",
  },
  {
    name: "Gbola Atitebi MBA, PMP, ITIL",
    description1:
      "Dynamics Platform Owner / BC Ministry of Attorney General - BC Public Service",
    description2: "AI Product Development",
    image: "/mentors/Gbola Atitebi.png",
    link: "https://www.linkedin.com/in/arogegbola/?originalSubdomain=ca",
  },
  {
    name: "Jacky Ma",
    description1: "Director of AI - Remerge",
    description2: "AI Transformation Leader",
    image: "/mentors/Mr Jacky Ma.png",
    link: "https://www.linkedin.com/in/jackyma/",
  },
  {
    name: "Allison Ehrke",
    description1: "Eli Lilly & Company",
    description2: "Lead Al Designer & Strategist",
    image: "/mentors/Ms. Allison Ehrke  .png",
    link: "https://www.linkedin.com/in/allisonehrke/",
  },
];

const TeamSection = () => {
  const handleMentorClick = (link) => {
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="bg-gray-100 py-12 px-6 sm:px-10 lg:px-16 flex justify-center">
      <div className="max-w-7xl w-full">
        {/* Section Header */}
        <div className="text-center mb-10">
          <p className="text-sm font-semibold text-blue-500 flex items-center gap-2 justify-center">
            ALL MEMBERS
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mt-2">
            Meet Our <span className="text-custom-pink">Mentors</span>
          </h2>
        </div>

        {/* Team Member Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 justify-items-center items-stretch">
          {teamMembers.map((member, index) => (
            <div key={index} onClick={() => handleMentorClick(member.link)} className="cursor-pointer">
              <TeamMemberCard
                key={index}
                image={member.image}
                name={member.name}
                description1={member.description1}
                description2={member.description2}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
